import { api, unwrap } from '@saas-kit/lib';

export interface AdminUser {
  id: string;
  email: string;
  full_name: string | null;
  is_active: boolean;
  is_superuser: boolean;
  is_verified: boolean;
  created_at: string;
  updated_at: string;
}

export interface AdminPage {
  total: number;
  offset: number;
  limit: number;
}

export interface AdminUserList {
  items: AdminUser[];
  page: AdminPage;
}

export interface ListUsersParams {
  offset?: number;
  limit?: number;
  email?: string | null;
}

export interface CreateUserPayload {
  email: string;
  password: string;
  full_name?: string;
  is_superuser?: boolean;
}

export async function listUsers(
  params: ListUsersParams = {},
): Promise<AdminUserList> {
  const query: Record<string, string | number> = {
    offset: params.offset ?? 0,
    limit: params.limit ?? 25,
  };
  if (params.email && params.email.trim()) {
    query.email = params.email.trim();
  }
  return unwrap<AdminUserList>(api.get('/admin/users', { params: query }));
}

export async function createUser(payload: CreateUserPayload): Promise<AdminUser> {
  return unwrap<AdminUser>(api.post('/admin/users', payload));
}

export async function suspendUser(userId: string): Promise<AdminUser> {
  return unwrap<AdminUser>(api.post(`/admin/users/${userId}/suspend`));
}

export async function reactivateUser(userId: string): Promise<AdminUser> {
  return unwrap<AdminUser>(api.post(`/admin/users/${userId}/reactivate`));
}
